const categoryToastMsg = {
  /**
   * [카테고리 생성 관리]
   * 카테고리 리스트 가져오기
   */
  GET_CATEGORY_LIST_REQUEST_SUCCESS: '카테고리 생성 리스트 데이터 가져오기 성공',
  GET_CATEGORY_LIST_REQUEST_ERROR: '카테고리 생성 리스트 데이터 가져오기 실패',

  /**
   * [카테고리 삭제 관리]
   * 카테고리 리스트 삭제하기
   */
  DELETE_CATEGORY_LIST_REQUEST_SUCCESS: '카테고리 리스트 삭제하기 성공',
  DELETE_CATEGORY_LIST_REQUEST_ERROR: '카테고리 리스트 삭제하기 실패',

  /**
   * [카테고리 생성 관리]
   * 카테고리 상세 데이터 가져오기
   */
  GET_CATEGORY_DETAIL_REQUEST_SUCCESS: '카테고리 상세 데이터 가져오기 성공',
  GET_CATEGORY_DETAIL_REQUEST_ERROR: '카테고리 상세 데이터 가져오기 실패',

  /**
   * [카테고리 생성 관리]
   * 카테고리 상품 리스트 가져오기
   */
  GET_CATEGORY_PRODUCT_LIST_REQUEST_SUCCESS: '카테고리 상품 리스트 가져오기 성공',
  GET_CATEGORY_PRODUCT_LIST_REQUEST_ERROR: '카테고리 상품 리스트 가져오기 실패',

  /**
   * [카테고리 생성 관리]
   * 카테고리 상품 정보 삭제하기
   */
  DELETE_CATEGORY_PRODUCT_REQUEST_SUCCESS: '카테고리 상품 정보 삭제하기 성공',
  DELETE_CATEGORY_PRODUCT_REQUEST_ERROR: '카테고리 상품 정보 삭제하기 실패',

  /**
   * [카테고리 생성 관리]
   * 카테고리 편집하기
   */
  EDIT_CATEGORY_REQUEST_SUCCESS: '카테고리 편집하기 성공',
  EDIT_CATEGORY_REQUEST_ERROR: '카테고리 편집하기 실패',

  /**
   * [카테고리 전시 관리]
   * 카테고리 전시 설정 데이터 가져오기
   */
  GET_CATEGORY_LIST_TREE_SUCCESS: '카테고리 전시 설정 데이터 가져오기 성공',
  GET_CATEGORY_LIST_TREE_ERROR: '카테고리 전시 설정 데이터 가져오기 실패',

  /**
   * [카테고리 전시 관리]
   * 카테고리 전시 설정 편집하기
   */
  EDIT_CATEGORY_EXHIBIT_ORDER_SUCCESS: '카테고리 전시 설정 편집하기 성공',
  EDIT_CATEGORY_EXHIBIT_ORDER_ERROR: '카테고리 전시 설정 편집하기 실패',

  /**
   * [카테고리 전시 관리]
   * 카테고리 최대 전시 갯수 초과
   */
  CATEGORY_EXHIBIT_MAX_SIZE_ERROR: '최대 전시 갯수를 초과 하였습니다.',

  /**
   *  1차 카테고리와 연결된 상품 개수 데이터 요청하기
   */
  GET_MAIN_CATEGORY_CONNECTED_PRODUCT_COUNT_DATA_REQUEST_ERROR: '카테고리와 연결된 상품 개수 데이터 요청하기 실패',

  /**
   *  카테고리 노출설정 상세 데이터 가져오기
   */
  GET_CATEGORY_EXPOSE_DETAIL_REQUEST_SUCCESS: '카테고리 노출설정 상세 데이터 가져오기 성공',
  GET_CATEGORY_EXPOSE_DETAIL_REQUEST_ERROR: '카테고리 노출설정 상세 데이터 가져오기 실패',

  /**
   *  1차 카테고리 노출설정 상세 데이터 가져오기
   */
  GET_MAIN_CATEGORY_EXPOSE_DETAIL_REQUEST_ERROR: '카테고리 노출설정 상세 데이터 가져오기 실패',

  /**
   *  2차 카테고리 노출설정 상세 데이터 가져오기
   */
  GET_SUB_CATEGORY_EXPOSE_DETAIL_REQUEST_ERROR: '카테고리 노출설정 상세 데이터 가져오기 실패',

  /**
   *  [카테고리 노출설정]
   *  카테고리 노출설정 편집하기
   */
  EDIT_CATEGORY_EXPOSE_REQUEST_SUCCESS: '카테고리 노출설정 편집하기 성공',
  EDIT_CATEGORY_EXPOSE_REQUEST_ERROR: '카테고리 노출설정 편집하기 실패',
  /**
   * [카테고리 배너 관리]
   */
  UPSERT_CATEGORY_BANNER_SUCCESS: '카테고리 배너 저장 성공',
  DELETE_CATEGORY_BANNER_SUCCESS: '카테고리 배너 삭제 성공',
};

export default categoryToastMsg;
